import cx from 'classnames';
import ImgCropped, { ImgCropMode } from 'mk2/components/ImgCropped';
import { PhotoEntity } from 'mk2/schemas';
import React from 'react';
import styles from './ListItemIcon.mscss';

interface OwnProps {
    /** Photo entity data */
    photo?: PhotoEntity;

    /** If true, image is loaded only if it comes to viewport */
    lazy?: boolean;

    /** Allow to specify which photo version should be used */
    photoVersion?: string;
}

export const ListItemIcon = React.memo<OwnProps>(({ photo, lazy, photoVersion = 's96x96' }) =>
    photo ? (
        <ImgCropped
            photo={photo}
            photoVersion={photoVersion}
            className={styles.ListItemIcon}
            width={32}
            height={32}
            mode={ImgCropMode.Cover}
            lazy={lazy}
        />
    ) : (
        <div className={cx(styles.ListItemIcon, styles['ListItemIcon--empty'])} />
    ),
);
